import React, { Component, Fragment } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import {
  getDispatches,
  setDispatch,
  addDispatch,
  updateDispatchById,
  removeDispatch,
  setPagination
} from "../../modules/dispatch";
import DispatchStatus from "../DispatchStatus";
import HasPermission from "../HasPermission";
import { setDispatchesView } from "../../modules/settings";
import { setStatus, setCreatedByMe } from "../../modules/search";
import {
  Row,
  Col,
  Spin,
  message,
  Table,
  Tag,
  Tooltip,
  Radio,
  Icon,
  Divider,
  Switch,
  Button,
  Input
} from "antd";
import { on } from "../../utils/sockets";
import DispatchItem from "../DispatchItem";
import SearchBox from "../SearchBox";
import DispatchControl from "../DispatchControl";
import moment from "moment";
import _ from "lodash";
import LeasingIcon from "../../assets/leasing.svg";

import "./index.css";

class DispatchList extends Component {
  state = {
    searchText: "",
    searchedColumn: ""
  };

  componentDidMount() {
    this.mounted = true;
    this.target = window.document.querySelector(".rightside");
    this.props.getDispatches();
    on("dispatch", msg => {
      if (this.mounted) {
        if (msg.verb === "created") {
          this.props.addDispatch(msg.data);
        }
        if (msg.verb === "updated") {
          this.props.updateDispatchById(msg.id);
          message.success(`Dispatch ${msg.verb}`);
        }
        if (msg.verb === "addedTo") {
          this.props.updateDispatchById(msg.id);
        }
        if (msg.verb === "destroyed") {
          this.props.removeDispatch(msg.id);
        }
      }
    });
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  getItems() {
    let filteredItems = this.props.items;
    const statusList = [
      "createdAt",
      "receivedAt",
      "approvedAt",
      "startedAt",
      "finishedAt",
      "closedAt",
      "canceledAt",
      "sapAt",
      "billedAt"
    ];

    if (this.props.status && this.props.status.length) {
      filteredItems = _.filter(filteredItems, item => {
        for (const status of this.props.status) {
          const index = _.findIndex(statusList, s => s === status);
          if (index !== -1 && item[status]) {
            const range = _.range(index + 1, statusList.length);
            let checkNextStatus = false;
            for (const i of range) {
              if (item[statusList[i]]) {
                checkNextStatus = true;
                break;
              }
            }
            if (checkNextStatus) {
              continue;
            }
            return true;
          }
        }
        return false;
      });
    }

    if (this.props.type && this.props.type.length) {
      filteredItems = _.filter(
        filteredItems,
        item => item.type && this.props.type.includes(item.type.id)
      );
    }

    if (this.props.query) {
      const query = this.props.query.toUpperCase();

      if (
        this.props.query.length > 3 &&
        !this.props.query.match(/TMS-|([A-Z]{3,}:)/i)
      ) {
        filteredItems = _.filter(filteredItems, item => {
          if (
            item.createdBy &&
            `${item.createdBy.name} ${item.createdBy.lastName}`
              .toUpperCase()
              .includes(query)
          ) {
            return true;
          }

          if (
            item.customer &&
            item.customer.name.toUpperCase().includes(query)
          ) {
            return true;
          }

          if (
            item.supplier &&
            item.supplier.name.toUpperCase().includes(query)
          ) {
            return true;
          }

          if (
            item.economicNumber &&
            item.economicNumber.toUpperCase().includes(query)
          ) {
            return true;
          }

          if (
            item.billType &&
            item.billType.name.toUpperCase().includes(query)
          ) {
            return true;
          }

          if (
            item.vehicle &&
            item.vehicle.economicNumber.toUpperCase().includes(query)
          ) {
            return true;
          }

          if (
            item.vehicletype &&
            item.vehicletype.name.toUpperCase().includes(query)
          ) {
            return true;
          }

          if (
            item.driver &&
            item.driver.name &&
            item.driver.name.toUpperCase().includes(query)
          ) {
            return true;
          }

          if (item.currency && item.currency.toUpperCase().includes(query)) {
            return true;
          }

          for (const reference of item.references) {
            if (reference.reference.toUpperCase().includes(query)) {
              return true;
            }
          }
        });
      }
    }

    if (this.props.createdByMe) {
      filteredItems = _.filter(
        filteredItems,
        item => item.createdBy.id === this.props.user.id
      );
    }

    return filteredItems;
  }

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({
      setSelectedKeys,
      selectedKeys,
      confirm,
      clearFilters
    }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e =>
            setSelectedKeys(e.target.value ? [e.target.value] : [])
          }
          onPressEnter={() =>
            this.handleSearch(selectedKeys, confirm, dataIndex)
          }
          style={{ width: 188, marginBottom: 8, display: "block" }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? "#1890ff" : undefined }} />
    ),
    onFilter: (value, record) => {
      if (dataIndex.includes(".")) {
        const split = dataIndex.split(".");

        if (record[split[0]]) {
          return record[split[0]][split[1]]
            .toString()
            .toLowerCase()
            .includes(value.toLowerCase());
        }
      } else {
        return record[dataIndex]
          .toString()
          .toLowerCase()
          .includes(value.toLowerCase());
      }
    },
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    }
  });

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: "" });
  };

  handlePagination = (page, size) => {
    this.props.setPagination(page, size || 10);
  };

  handleConvertToCurrentCurrency = (currency, supplierCost, exchangeRate) => {
    if (currency === "MXN") {
      return supplierCost / exchangeRate;
    }

    return supplierCost * exchangeRate;
  };

  render() {
    const items = this.getItems();
    const total = items.length || 0;
    const colLg = { offset: 0, span: 24 };

    const colXl =
      this.props.dispatchesView === "cards" ? { offset: 3, span: 18 } : colLg;

    const columns = [
      {
        title: "",
        dataIndex: "extraCharges",
        key: "extraCharges",
        fixed: "left",
        width: 50,
        render: (text, record) => {
          const charges = _.get(record, "charge", []);
          const hasExtraChargesPendingToTransmit = charges.some(
            c => !c.transmitted
          );
          return (
            <Row gutter={16}>
              <Col span={12}>
                <a>
                  {(hasExtraChargesPendingToTransmit && (
                    <Icon type="info-circle" theme="twoTone" />
                  )) ||
                    ""}
                </a>
              </Col>
              <Col span={12}>
                <a>
                  {(record.stamp && (
                    <Icon
                      type="check-circle"
                      theme="twoTone"
                      twoToneColor="#52c41a"
                    />
                  )) ||
                    ""}
                </a>
              </Col>
            </Row>
          );
        },
        ellipsis: true
      },
      {
        title: "Tránsito",
        dataIndex: "id",
        key: "id",
        fixed: "left",
        width: 100,
        render: (text, record) => {
          return <a>{String(record.id).padStart(5, "0")} </a>;
        },
        sorter: (a, b) => a.id - b.id,
        ...this.getColumnSearchProps("id"),
        ellipsis: true
      },
      {
        title: "Fecha",
        dataIndex: "createdAt",
        key: "createdAt",
        render: createdAt => moment(createdAt).format("lll"),
        sorter: (a, b) =>
          moment(a.createdAt).unix() - moment(b.createdAt).unix()
      },
      {
        title: "Movimiento",
        dataIndex: "type",
        key: "type",
        render: type => type && type.name,
        className: "tablecolumns"
      },
      {
        title: "Clave SAP",
        dataIndex: "customer",
        key: "sap_number",
        render: customer => customer && customer.sapId,
        ...this.getColumnSearchProps("customer.sapId")
      },
      {
        title: "Cliente",
        dataIndex: "customer",
        key: "customer",
        render: customer => customer && customer.name,
        ...this.getColumnSearchProps("customer.name")
      },
      {
        title: "Proveedor",
        dataIndex: "supplier",
        key: "supplier",
        render: supplier => (supplier ? supplier.name : "N/A"),
        ...this.getColumnSearchProps("supplier.name")
      },
      {
        title: "Importe",
        dataIndex: "amount",
        key: "amount",
        render: (text, record) => {
          return (
            <div
              className={`${!record.amount ? "dispatch-amount-warning" : ""}`}
            >
              <Tooltip
                title={
                  !record.amount
                    ? "Tránsito sin importe"
                    : "Importe más cargos extras"
                }
              >
                $
                {DispatchItem.getTotal(record)
                  .toFixed(2)
                  .replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")}
              </Tooltip>
            </div>
          );
        },
        sorter: (a, b) => (a.amount ? a.amount : 0) - (b.amount ? b.amount : 0)
      },
      {
        title: "Rentabilidad",
        dataIndex: "profit",
        key: "profit",
        render: (text, record) => {
          const {
            amount,
            currency,
            supplierCost,
            supplierExtraChargesCost,
            charges
          } = record;

          const hasProfit = !!supplierCost;

          if (!hasProfit) return 'N/A';

          const exchangeRate = _.get(record, "exchangeRate", 1);
          const supplierCurrency = record.currency || "MXN";

          const supplierCostToCurrentCurrency =
            currency === supplierCurrency
              ? supplierCost
              : this.handleConvertToCurrentCurrency(
                  supplierCurrency,
                  supplierCost,
                  exchangeRate
                );

          const chargesAmount = _.sumBy(charges || [], "amount");
          const total = amount + (chargesAmount || 0);

          const profit = hasProfit
            ? total -
              supplierCostToCurrentCurrency -
              (supplierExtraChargesCost || 0)
            : 0;

          return <span>{`$ ${profit.toFixed(2)}`}</span>;
        }
      },
      {
        title: "Renta",
        dataIndex: "isLeasing",
        key: "isLeasing",
        render: (text, record) => {
          if (record.isLeasing) {
            return (
              <Tag color="#001524">
                <img
                  src={LeasingIcon}
                  style={{ color: "#fff", marginRight: 8 }}
                  alt="icon"
                />
                Renta
              </Tag>
            );
          }
          if (record.isCollection) {
            return <Tag color="#10619A">Recolección</Tag>;
          }
          return null;
        }
      },
      {
        title: "Estatus",
        dataIndex: "status",
        key: "status",
        fixed: "right",
        width: 100,
        render: (text, record) => {
          const status = DispatchItem.getStatus(record);

          return (
            <Tooltip title={status.title}>
              <Tag className={status.badgeClassName}>
                {status.name.includes("cancelado")
                  ? "Viaje cancelado"
                  : status.name}
              </Tag>
            </Tooltip>
          );
        }
      },
      {
        title: "Controles",
        dataIndex: "controles",
        key: "controles",
        fixed: "right",
        width: 100,
        render: (text, record) => {
          return <DispatchControl id={record.id} />;
        }
      }
    ];

    return (
      <div>
        <Row gutter={10} style={{ marginBottom: 10 }}>
          <Col lg={colLg} xl={colXl}>
            <SearchBox items={_.map(items, "id")} total={total} />
          </Col>
        </Row>
        {!this.props.fetching && total >= 1 && (
          <Row gutter={10} style={{ marginTop: 10, marginBottom: 10 }}>
            <Col style={{ display: "flex" }} lg={colLg} xl={colXl}>
              <span>
                Se obtuv{total > 1 ? "ieron" : "o"} {total} resultado
                {total > 1 ? "s" : ""}.
              </span>
              <span style={{ marginLeft: "auto" }}>Sólo mis tránsitos</span>
              <Switch
                checked={this.props.createdByMe}
                onChange={val => this.props.setCreatedByMe(val)}
                style={{ marginLeft: 10 }}
              />
              <Radio.Group
                onChange={e => {
                  this.props.setDispatchesView(e.target.value);
                }}
                value={this.props.dispatchesView}
                style={{ marginLeft: 20 }}
                size={"small"}
              >
                <Radio.Button value={"cards"}>
                  <Icon type={"bars"} />
                </Radio.Button>
                <Radio.Button value={"table"}>
                  <Icon type={"table"} />
                </Radio.Button>
              </Radio.Group>
            </Col>
          </Row>
        )}
        {!this.props.fetching && !this.props.unauthorized && total < 1 && (
          <div style={{ marginBottom: 0 }} className={"dispatch-empty"}>
            <span>No se encontraron resultados.</span>
            {this.props.createdByMe && (
              <Fragment>
                <span style={{ marginLeft: 10 }}>Sólo mis tránsitos</span>
                <Switch
                  checked={this.props.createdByMe}
                  onChange={val => this.props.setCreatedByMe(val)}
                  style={{ marginLeft: 10 }}
                />
              </Fragment>
            )}
          </div>
        )}
        {this.props.fetching && total < 1 && (
          <div style={{ textAlign: "center", marginTop: 15, marginBottom: 15 }}>
            <Spin spinning />
          </div>
        )}
        {this.props.dispatchesView === "cards" && (
          <div>
            <Spin spinning={total >= 1 && this.props.fetching}>
              {items.map(i => (
                <Row key={i.id} gutter={10}>
                  <Col
                    lg={colLg}
                    xl={this.props.dispatchesView === "cards" ? colXl : {}}
                  >
                    <DispatchItem
                      id={i.id}
                      active={i.id === this.props.selected}
                    />
                  </Col>
                </Row>
              ))}
            </Spin>
          </div>
        )}
        {Boolean(total) && this.props.dispatchesView === "table" && (
          <Row gutter={10}>
            <Col lg={colLg} xl={colXl}>
              <Table
                rowKey={"id"}
                scroll={{ x: 1300 }}
                style={{ backgroundColor: "#fff" }}
                pagination={{
                  total: this.props.pagination.total,
                  pageSize: this.props.pagination.pageSize,
                  current: this.props.pagination.page,
                  onChange: page => this.handlePagination(page)
                }}
                loading={this.props.fetching}
                columns={columns}
                dataSource={items}
                expandedRowRender={record => (
                  <div>
                    <HasPermission name={"Editar"}>
                      <DispatchStatus id={record.id} />
                      <Divider />
                    </HasPermission>
                    <p style={{ margin: 0 }}>
                      {record.cancelComment ||
                        record.comments ||
                        "Sin comentarios"}
                    </p>
                  </div>
                )}
                onRow={record => {
                  return {
                    onClick: row => {
                      this.props.setDispatch(record.id, record);
                    }
                  };
                }}
              />
            </Col>
          </Row>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  user: state.auth.user,
  unauthorized: state.auth.unauthorized,
  fetching: state.dispatch.fetching,
  items: state.dispatch.items,
  selected: state.dispatch.selected,
  query: state.search.query,
  type: state.search.type,
  createdByMe: state.search.createdByMe,
  status: state.search.status,
  dispatchesView: state.settings.dispatchesView,
  record: state.dispatch.record,
  pagination: state.dispatch.pagination
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      getDispatches,
      setDispatch,
      addDispatch,
      updateDispatchById,
      removeDispatch,
      setDispatchesView,
      setCreatedByMe,
      setStatus,
      setPagination
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DispatchList);



// WEBPACK FOOTER //
// ./src/containers/DispatchList/index.js